import { trackAPIMethods } from '../tracking';
import { Modifier } from './modifier';

export const modifyContent = (init, location, modifierObject) => {
	const modifier = new Modifier(init, location, modifierObject);
	modifier.apply();

	trackAPIMethods(init, { methodType: 'modifyContent', location });
};
